module.exports = __webpack_public_path__ + "static/media/logomarca-top-w.26ee63ff.26ee63ff.svg";